const projects = [
  {
    title: "UpperCrust Pizza",
    description:
      "Developed Vue front end of a mobile-first, responsively designed, full-stack web application for a hypothetical pizza shop, enabling customers to place orders and employees to manage menu. Instituted routing with Vue Router and managed state with Vuex. Maintained close communication with back-end team to ensure seamless integration between client and server.",
    highlights:
      "Vue, Vuex, Vue Router, Java, Spring Boot, PostgreSQL, JSON Web Tokens (JWT), RESTful API, Responsive",
    imagePath: "uppercrust-pizza.d2e8b87c.png",
    seeLiveLink: "https://d-mcneil.github.io/uppercrust-pizza",
    firstSourceCodeLink: "https://github.com/d-mcneil/uppercrust-pizza/tree/main/vue",
    firstSourceCodeLabel: "Source Code - Front",
    secondSourceCodeLink: "https://github.com/d-mcneil/uppercrust-pizza/tree/main/java",
    secondSourceCodeLabel: "Source Code - Back",
  },
  {
    title: "Flashcards Study Application",
    description:
      "Engineered a full-stack, progressive web application with responsive design using React, Redux, Node, Express, and PostgreSQL that lets users create, store, modify, study, and delete their own flashcard decks. Incorporated the JavaScript Web Speech API to add read-aloud functionality.",
    highlights:
      "React, Redux, Node, Express, PostgreSQL, CRUD, PWA, Responsive",
    imagePath: "flashcards-study-application.1abcfa40.png",
    seeLiveLink: "https://d-mcneil.github.io/flashcards",
    firstSourceCodeLink: "https://github.com/d-mcneil/flashcards",
    firstSourceCodeLabel: "Source Code - Front",
    secondSourceCodeLink: "https://github.com/d-mcneil/flashcards-api",
    secondSourceCodeLabel: "Source Code - Back",
  },
  {
    title: "TEnmo Money Transfers",
    description:
      "Employed pair programming methodology to collaboratively develop a Java Spring Boot application that models money transfers between users. Secured REST API endpoints using JSON Web Tokens (JWT) for authentication. Encapsulated interactions with PostgreSQL database utilizing the DAO design pattern. Performed integration testing and data validation to maintain data integrity.",
    highlights:
      "Java, Spring Boot, PostgreSQL, JSON Web Tokens (JWT), RESTful API, Integration Testing, JUnit, DAO Design Pattern, Object-Oriented Programming (OOP)",
    imagePath: "tenmo-money-transfers.ab953f30.png",
    firstSourceCodeLink: "https://github.com/d-mcneil/tenmo-transfers",
    firstSourceCodeLabel: "Source Code",
    imageLink: "https://github.com/d-mcneil/tenmo-transfers",
  },
  {
    title: "Virtual Vending Machine",
    description:
      "Collaborated with a fellow software developer to design a Java-based, virtual vending machine. Demonstrated proficiency in applying the 4 main principles of object-oriented programming, resulting in an extensible, maintainable codebase. Utilized file I/O operations effectively to track inventory and log user activity. Wrote unit tests to ensure proper functionality.",
    highlights: "Java, Unit Testing, JUnit, OOP",
    imagePath: "virtual-vending-machine.c218e313.png",
    seeLiveLink: "https://replit.com/@dmcneil/vending-machine?v=1",
    firstSourceCodeLink: "https://github.com/d-mcneil/vending-machine",
    firstSourceCodeLabel: "Source Code",
  },
  {
    title: "Pokémon Stat Calculator",
    description:
      "Created a front-end, mobile-first, progressive web application with responsive design using React and Redux. Implemented client-side routing with React Router. Connected to the PokéAPI to automatically populate input fields.",
    highlights: "React, Redux, React Router, PWA, Responsive",
    imagePath: "pokemon-stat-calculator.c37739b7.png",
    seeLiveLink: "https://d-mcneil.github.io/pokemon-calculator/",
    firstSourceCodeLink: "https://github.com/d-mcneil/pokemon-calculator",
    firstSourceCodeLabel: "Source Code",
  },
  {
    title: "SmartBrain Face Detection",
    description:
      "Developed a full-stack web application with responsive design using React, Node, Express, and PostgreSQL as part of Zero to Mastery Academy’s Complete Web Developer curriculum. Integrated Clarifai's API to detect faces in images, the user’s total score is increased, and their rank is displayed compared to all SmartBrain users.",
    highlights: "React, Node, Express, PostgreSQL, CRUD, Responsive",
    imagePath: "smartbrain-face-detection.34cc7675.png",
    seeLiveLink: "https://d-mcneil.github.io/smartbrain",
    firstSourceCodeLink: "https://github.com/d-mcneil/smartbrain",
    firstSourceCodeLabel: "Source Code - Front",
    secondSourceCodeLink:
      "https://github.com/d-mcneil/smartbrain-face-detection-api",
    secondSourceCodeLabel: "Source Code - Back",
  },
  {
    title: "Pokémon Breeding Compatibility Checker",
    description:
      "In the main Pokémon games, Pokémon can breed with other Pokémon in their egg group. This app lets you search by Pokémon to find those it can breed with.",
    highlights: "React, Redux, Bootstrap, PWA, Responsive",
    // picture from https://www.ign.com/wikis/pokemon-go/Eggstravaganza_Event_-_April_2017
    imagePath: "pokemon-breeding-compatibility-checker.0b46d72c.png",
    seeLiveLink:
      "https://d-mcneil.github.io/pokemon-breeding-compatibility-checker",
    firstSourceCodeLink:
      "https://github.com/d-mcneil/pokemon-breeding-compatibility-checker",
    firstSourceCodeLabel: "Source Code",
  },
  {
    title: "RoboFriends",
    description:
      "Search through all of your friends (personified as robots) to find their contact information.",
    highlights: "React, Redux, PWA, Responsive",
    imagePath: "robofriends.b0f367bb.png",
    seeLiveLink: "https://d-mcneil.github.io/robofriends-redux",
    firstSourceCodeLink: "https://github.com/d-mcneil/robofriends-redux",
    firstSourceCodeLabel: "Source Code",
  },
  {
    title: "Website Layout CSS Grid",
    description: "A sample website layout",
    highlights: "CSS Grid, Responsive",
    imagePath: "website-layout-css-grid.30de2e86.png",
    seeLiveLink: "https://d-mcneil.github.io/website-layout-css-grid",
    firstSourceCodeLink: "https://github.com/d-mcneil/website-layout-css-grid",
    firstSourceCodeLabel: "Source Code",
  },
  {
    title: "Background Gradient Generator",
    description:
      "Create a simple background gradient and copy the CSS code to use it for your own website. If you aren't feeling inspired, you can generate random gradients until you find one that you like.",
    highlights: "JavaScript, Responsive",
    imagePath: "background-gradient-generator.f5564c70.png",
    seeLiveLink: "https://d-mcneil.github.io/background-gradient-generator",
    firstSourceCodeLink:
      "https://github.com/d-mcneil/background-gradient-generator",
    firstSourceCodeLabel: "Source Code",
  },
  {
    title: "Password Checker haveibeenpwned.com",
    description:
      "Check passwords against the haveibeenpwned.com database to see if any of your passwords have been leaked in a data breach. Unlike simply going to haveibeenpwned.com and entering your passwords, this app lets you check passwords without sending them over the Internet (when used locally).",
    highlights: "Python",
    imagePath: "password-checker-haveibeenpwned.c22ad4ce.png",
    seeLiveLink:
      "https://replit.com/@dmcneil/password-checker-have-i-been-pwned?v=1",
    firstSourceCodeLink:
      "https://github.com/d-mcneil/password-checker-have-i-been-pwned",
    firstSourceCodeLabel: "Source Code",
  },
  {
    title: "Scrape Hacker News Top Stories",
    description:
      "This app returns all of the stories on Hacker News that have more than 100 up-votes. You can choose how many pages to scrape from, but there is a 30-second delay between scraping each page.",
    highlights: "Python, Scraper, Beautiful Soup",
    imagePath: "scrape-hacker-news-top-stories.78a55f9b.png",
    seeLiveLink:
      "https://replit.com/@dmcneil/scrape-hacker-news-top-stories?v=1",
    firstSourceCodeLink:
      "https://github.com/d-mcneil/scrape-hacker-news-top-stories",
    firstSourceCodeLabel: "Source Code",
  },
  {
    title: "Flask Portfolio",
    description:
      "This alternative portfolio website was created by taking a template from mashup-template.com, using the Flask framework to program the server, and hosting it on pythonanywhere.com.",
    highlights: "Python, Flask",
    imagePath: "flask-portfolio.a6b17744.png",
    seeLiveLink: "https://dmcneil.pythonanywhere.com/",
    firstSourceCodeLink: "https://github.com/d-mcneil/flask-portfolio",
    firstSourceCodeLabel: "Source Code",
  },
  {
    title: "Guess the Number",
    description:
      "If you're incredibly bored and have nothing else to do, play this game against the computer where you each take turns guessing the other's number.",
    highlights: "Python",
    imagePath: "guess-the-number.eab515ae.png",
    seeLiveLink: "https://replit.com/@dmcneil/guess-the-number?v=1",
    firstSourceCodeLink: "https://github.com/d-mcneil/guess-the-number",
    firstSourceCodeLabel: "Source Code",
  },
  //   {
  //     title: "",
  //     description: "",
  //     highlights: "",
  //     seeLiveLink: "",
  //     firstSourceCodeLink: "",
  //     firstSourceCodeLabel: "",
  //     secondSourceCodeLink: "",
  //     secondSourceCodeLabel: "",
  //     imageLink: "",
  //     imagePath: "",
  //   },
];

export default projects;
